AFRAME.registerComponent('sip-filters', {
    schema: {
        minPrice: {type: 'number', default: 1},
        minCap: {type: 'number', default: 10 * 10 ** 9},
        theme: {type: 'string', default: 'Dark'}
    },

    init: function () {
        this.scene = document.querySelector('a-scene');

        const mainSettings = document.querySelector('[main-settings]');
        if (mainSettings) {
            this.data.theme = mainSettings.getAttribute('main-settings').themeMode || 'Dark';
        }

        this.createFilters();

        this.onThemeChanged = this.onThemeChanged.bind(this);
        this.scene.addEventListener('theme-changed', this.onThemeChanged);
    },

    remove: function () {
        if (this.scene) {
            this.scene.removeEventListener('theme-changed', this.onThemeChanged);
        }
    },

    onThemeChanged: function (evt) {
        this.data.theme = evt.detail.themeMode || evt.detail.theme || 'Dark';
        this.createFilters();
    },

    createFilters: function() {
        this.el.innerHTML = ''
        const self = this
        const isLight = this.data.theme === 'Light';

        const lineColor = isLight ? '#E5E5EA' : '#2B2B32';
        const thumbColor = isLight ? '#3636E3' : '#fff';
        const arrowColor = isLight ? '#E5E5EA' : '#222';
        const arrowHoverColor = isLight ? '#D1D1D6' : '#2B2B32';
        const textColor = isLight ? '#14141C' : '#fff';
        const subTextColor = isLight ? '#666' : '#89898D';
        const arrowTextColor = isLight ? '#14141C' : '#fff';

        const minBlock = createBlock(
            'Minimum price',
            this.data.minPrice,
            1,
            100,
            decreaseMinPrice,
            increaseMinPrice
        )
        minBlock.setAttribute('position', '0 0.2 0')
        this.el.appendChild(minBlock)
        const maxBlock = createBlock(
            'Minimum Market cap',
            this.data.minCap,
            10 * 10 ** 9,
            10 ** 12,
            decreaseMinCap,
            increaseMinCap
        )
        maxBlock.setAttribute('position', '0 -0.2 0')
        this.el.appendChild(maxBlock)


        function createBlock(title, currentValue, minValue, maxValue, leftAction, rightAction) {
            const block = document.createElement('a-entity')

            const line = document.createElement('a-rounded-box')
            line.setAttribute('width', '0.44')
            line.setAttribute('height', '0.02')
            line.setAttribute('depth', '0.05')
            line.setAttribute('radius', '0.05')
            line.setAttribute('color', lineColor)
            block.appendChild(line)

            const thumb = document.createElement('a-rounded-box')
            thumb.setAttribute('width', '0.04')
            thumb.setAttribute('height', '0.04')
            thumb.setAttribute('depth', '0.1')
            thumb.setAttribute('radius', '0.01')
            thumb.setAttribute('color', thumbColor)
            const positionX = ((currentValue - minValue) / (maxValue - minValue)) * 0.44 - 0.22
            thumb.setAttribute('position',  `${positionX} 0 0`)
            block.appendChild(thumb)

            const leftArrow = createArrow('<')
            leftArrow.setAttribute('position', '-0.35 0 0')
            leftArrow.addEventListener('click', leftAction)
            block.appendChild(leftArrow)
            const rightArrow = createArrow('>')
            rightArrow.setAttribute('position', '0.35 0 0')
            rightArrow.addEventListener('click', rightAction)
            block.appendChild(rightArrow)

            const titleText = document.createElement('a-text')
            titleText.setAttribute('value', title)
            titleText.setAttribute('color', textColor)
            titleText.setAttribute('anchor', 'left')
            // titleText.setAttribute('baseline', '0.06')
            // titleText.setAttribute('font-size', '0.05')
            titleText.setAttribute('scale', '0.25 0.25 0.25')
            titleText.setAttribute('position', '-0.41 0.12 0')
            block.appendChild(titleText)

            const minValueText = document.createElement('a-text')
            minValueText.setAttribute('value', '$' + self.formatNumbers(minValue))
            minValueText.setAttribute('color', subTextColor)
            minValueText.setAttribute('align', 'left')
            // minValueText.setAttribute('baseline', '0.06')
            // minValueText.setAttribute('font-size', '0.05')
            minValueText.setAttribute('scale', '0.25 0.25 0.25')
            minValueText.setAttribute('position', '-0.22 -0.1 0')
            block.appendChild(minValueText)

            const maxValueText = document.createElement('a-text')
            maxValueText.setAttribute('value', '$' + self.formatNumbers(maxValue))
            maxValueText.setAttribute('color', subTextColor)
            maxValueText.setAttribute('align', 'right')
            // maxValueText.setAttribute('baseline', '0.06')
            // maxValueText.setAttribute('font-size', '0.05')
            maxValueText.setAttribute('scale', '0.25 0.25 0.25')
            maxValueText.setAttribute('position', '0.22 -0.1 0')
            block.appendChild(maxValueText)

            const currentValueText = document.createElement('a-text')
            currentValueText.setAttribute('value', '$' + self.formatNumbers(currentValue))
            currentValueText.setAttribute('color', textColor)
            currentValueText.setAttribute('align', 'right')
            // currentValueText.setAttribute('baseline', '0.06')
            // currentValueText.setAttribute('font-size', '0.05')
            currentValueText.setAttribute('scale', '0.25 0.25 0.25')
            currentValueText.setAttribute('position', '0.41 0.12 0')
            block.appendChild(currentValueText)

            return block

            function createArrow(text) {
                const arrow = document.createElement('a-rounded-box')
                arrow.setAttribute('width', '0.12')
                arrow.setAttribute('height', '0.12')
                arrow.setAttribute('depth', '0.05')
                arrow.setAttribute('radius', '0.02')
                arrow.setAttribute('color', arrowColor)
                arrow.setAttribute('data-raycastable', '')

                const arrowText = document.createElement('a-text')
                arrowText.setAttribute('value', text)
                arrowText.setAttribute('color', arrowTextColor)
                arrowText.setAttribute('anchor', 'center')
                arrowText.setAttribute('align', 'center')
                arrowText.setAttribute('baseline', 'center')
                // arrowText.setAttribute('font-size', '0.08')
                arrowText.setAttribute('scale', '0.4 0.4 0.4')
                arrowText.setAttribute('position', '0 0 0.026')
                arrow.appendChild(arrowText)

                arrow.addEventListener('mouseenter', () => {
                    arrow.setAttribute('scale', '1.1 1.1 1.1')
                    arrow.setAttribute('color', arrowHoverColor)
                })
                arrow.addEventListener('mouseleave', () => {
                    arrow.setAttribute('scale', '1 1 1')
                    arrow.setAttribute('color', arrowColor)
                })


                return arrow
            }
        }

        function decreaseMinPrice() {
            let newValue = self.data.minPrice - 10
            if (newValue < 1) newValue = 1
            self.el.setAttribute('sip-filters', 'minPrice', newValue);
            if (self.scene) {
                self.scene.emit('sip-filters-changed', { minPrice: newValue, minCap: self.data.minCap });
            }
        }
        function increaseMinPrice() {
            let newValue = self.data.minPrice + 10
            if (newValue > 100) newValue = 100
            if (newValue === 11) newValue = 10
            self.el.setAttribute('sip-filters', 'minPrice', newValue);
            if (self.scene) {
                self.scene.emit('sip-filters-changed', { minPrice: newValue, minCap: self.data.minCap });
            }
        }
        function decreaseMinCap() {
            let currentValue = self.data.minCap;
            let step = 10 * 10 ** 9;
            let newValue = currentValue - step;
            if (newValue < 10 * 10 ** 9) {
                newValue = 10 * 10 ** 9;
            }
            self.el.setAttribute('sip-filters', 'minCap', newValue);
            if (self.scene) {
                self.scene.emit('sip-filters-changed', {
                    minPrice: self.data.minPrice,
                    minCap: newValue
                });
            }
        }
        function increaseMinCap() {
            let currentValue = self.data.minCap;
            let step = 10 * 10 ** 9;
            let newValue = currentValue + step;
            if (newValue > 10 ** 12) {
                newValue = 10 ** 12;
            }
            self.el.setAttribute('sip-filters', 'minCap', newValue);
            if (self.scene) {
                self.scene.emit('sip-filters-changed', {
                    minPrice: self.data.minPrice,
                    minCap: newValue
                });
            }
        }

    },

    formatNumbers: function(rawNumber) {
        if (rawNumber >= 10 ** 9 && rawNumber < 10 ** 12) return (rawNumber / 10 ** 9).toFixed(0) + 'B'
        if (rawNumber >= 10 ** 12) return (rawNumber / 10 ** 12).toFixed(0) + 'T'
        return rawNumber.toString()
    },

    update: function () {
        this.createFilters()
    }
})
